import { useMutation } from "@shared/lib/hooks";
import {
  BRIEF_LIST_QUERY_KEY,
  makeBriefDeliverableQueryKey,
  makeBriefDeliverablesQueryKey,
} from "../constants";
import { BriefService } from "../services/brief.service";

export function useSetDefaultDeliverable(briefId: string) {
  const {
    mutate: setDefaultDeliverable,
    isLoading: isSetting,
    isSuccess: isSet,
    isError: isSetError,
  } = useMutation({
    mutationFn: (data: { deliverableV2Id: string }) =>
      BriefService.setDefaultDeliverable({
        deliverableV2Id: data.deliverableV2Id,
        briefId,
      }),
    options: {
      queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
    },
    onSuccess: (c, _, { deliverableV2Id }) => {
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
      });
      c.invalidateQueries({
        queryKey: makeBriefDeliverablesQueryKey(briefId),
      });
      c.invalidateQueries({
        queryKey: makeBriefDeliverableQueryKey(deliverableV2Id),
      });
    },
  });

  return {
    setDefaultDeliverable,
    isSetting,
    isSet,
    isSetError,
  };
}
